export default __webpack_public_path__ + "static/media/airconditioner.e564f53a.webp";